<template>
  <el-dialog
    :modelValue="modelValue"
    @update:modelValue="emit('update:modelValue', $event)"
    class="new_dialog"
    width="725px"
    title="BGM提取"
  >
    <el-form
      class="form"
      ref="formRef"
      :model="formData"
      :rules="rules"
      hide-required-asterisk
      @submit.stop.prevent="submitForm(formRef)"
      v-loading="loading"
    >
      <el-form-item prop="url">
        <el-input
          class="textarea"
          v-model="formData.url"
          placeholder="请粘贴您的视频链接到此处"
          type="textarea"
          :rows="9"
        />
      </el-form-item>
      <el-button
        class="submit"
        type="primary"
        @click="submitForm(formRef)"
        :loading="reactiveData.loading"
        :disabled="reactiveData.disable_time > 0"
      >
        {{
          reactiveData.disable_time > 0 ? reactiveData.disable_time : '立即检测'
        }}
      </el-button>
      <a
        class="el-button el-button--primary"
        v-if="reactiveData.data"
        @click="audioHandle"
      >
        保存到本地
      </a>
      <el-button @click="clearHandle">清空内容</el-button>

      <div class="jc">
        <div class="audio" v-if="reactiveData.data">
          <audio :src="reactiveData.data" height="88" controls></audio>
        </div>
        <div class="steps" v-else>
          <div class="t1">复制视频链接教程</div>
          <el-steps :active="-1" align-center>
            <el-step title="打开短视频APP找到" description="[分享] 按钮" />
            <el-step title="点击" description="[复制链接]" />
            <el-step title="粘贴链接至本软件点击" description="[立即检测]" />
          </el-steps>
        </div>
      </div>
      <div class="desc">
        视频提取功能仅供自己视频测试学习，严禁商业用途视频版权归原作者所有，本
        <br />
        应用不存储任何视频和图片
      </div>
    </el-form>
  </el-dialog>
</template>

<script setup>
import { toRefs, ref, reactive, computed } from 'vue'
import { useStore } from 'vuex'
import { ElMessage } from 'element-plus'
import { tool4_find, douyin_exec_audio } from '@/utils/api'
import { douyin_download_audio, download } from '@/utils'

const store = useStore()
const { state } = store
const { loading } = toRefs(state)

const props = defineProps({
  modelValue: { type: Boolean },
})
const { modelValue } = toRefs(props)

const emit = defineEmits(['update:modelValue'])

const formRef = ref()

const rules = reactive({
  url: [{ required: true, message: '请输入关键词' }],
})

const reactiveData = reactive({
  loading: false,
  disable_time: 0,
  timer: null,
  // data: 'https://v26-cold.douyinvod.com/38b201766c73650a531e1137f981a2e0/63f9ce6f/video/tos/cn/tos-cn-ve-15c001-alinc2/oYoxLfBeCzxr9jA2ogC4A8CwIt0vNjAhAsU3EQ/?a=1128&ch=0&cr=0&dr=0&cd=0%7C0%7C0%7C0&cv=1&br=353&bt=353&cs=0&ds=3&ft=nK5C30071gOvGbhBH6xRfxSSgvBO56J6QPdz7tG&mime_type=video_mp4&qs=0&rc=ZTY5Z2g6NTU1Zjs1Ozs2O0Bpam5peGU6ZnE8aTMzNGkzM0A0YS1gYTQ0XzMxYy1jMDQyYSNsLjEzcjRvamhgLS1kLS9zcw%3D%3D&l=20230225160029F56EBF27215B2C5C8774&btag=a8000',
  data: '',
})

const formData = reactive({
  // url: 'https://v.douyin.com/BXYcXQE/',
  url: '',
})

const submitForm = async (formEl) => {
  if (!formEl) return
  await formEl.validate(async (valid, fields) => {
    if (valid) {
      try {
        reactiveData.loading = true
        reactiveData.disable_time = 5
        clearInterval(reactiveData.timer)
        reactiveData.timer = setInterval(() => {
          reactiveData.disable_time--
          if (reactiveData.disable_time <= 0) {
            clearInterval(reactiveData.timer)
          }
        }, 1000)
        const { data: res } = await tool4_find(formData)
        reactiveData.data = res.data
        reactiveData.loading = false
      } catch (error) {
        console.log(error)
        ElMessage.error(error.message)
        reactiveData.loading = false
      }
    } else {
      console.log('error submit!', fields)
    }
  })
}

const clearHandle = () => {
  formData.url = ''
  reactiveData.data = ''
}

const audioHandle = () => {
  douyin_exec_audio({
    url: reactiveData.data,
  }).then(({ data: res }) => {
    // const download_url = douyin_download_audio(res.data)
    // download(download_url)
    download(res.data)
  })
}
</script>

<style lang="scss" scoped>
.jc {
  margin-top: 30px;
  background: #122039;
  border-radius: 5px;
  border: 1px dashed #30456c;
  .steps {
    padding: 45px;
    .t1 {
      font-size: 16px;
      font-weight: bold;
      text-align: center;
      margin-bottom: 24px;
    }
    :deep(.el-step) {
      .el-step__icon {
        width: 44px;
        height: 44px;
        .el-step__icon-inner {
          font-size: 24px;
          font-weight: normal;
        }
      }
      .el-step__line {
        top: 21px;
      }
      .el-step__icon {
        background-color: #122039;
        border-color: #979797;
      }
      .el-step__description {
        color: #176af3;
        font-weight: bold;
        font-size: 16px;
      }
    }
  }
  .audio {
    display: flex;
    justify-content: center;
    align-items: center;
    iframe {
      height: 534px;
    }
  }
}
.desc {
  margin-top: 14px;
  line-height: 19px;
  color: #435371;
  text-align: center;
}
</style>
